import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

import { Link, useNavigate, useParams } from "react-router-dom"
import withRouter from "components/Common/withRouter"

import { useFormik } from "formik"

import toast from "react-hot-toast"
import {
  useLazyGetInvestorByTokenQuery,
  useUserResetPasswordMutation,
} from "store/api/investors/investors.api"
import logo from "../../assets/images/logo-light1.svg"
import eye from "../../assets/images/icons/eye.svg"
import hide from "../../assets/images/icons/hide.svg"
import Spinners from "components/Common/Spinner"

const ResetPassword = () => {
  //meta title
  document.title = "Reset Password | Prachay"

  const { token } = useParams()
  const [accountType, setAccountType] = useState("INVESTOR")

  const [getInvestor, { isFetching }] = useLazyGetInvestorByTokenQuery()
  const [update, { isLoading }] = useUserResetPasswordMutation()
  const [user, setUser] = useState()
  const [show, setShow] = useState(false)

  const history = useNavigate()

  const handlePasswordChange = async (params) => {
    try {
      params["accountType"] = accountType
      const { message, success } = await update(params).unwrap()
      if (success) {
        history("/login")
        toast.success(message, { id: "verifySuccess" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    // enableReinitialize: true,

    initialValues: {
      password: "",
      confirm_password: "",
    },
    onSubmit: (values) => {
      handlePasswordChange(values)
    },
  })

  const getUser = async () => {
    try {
      const { data, success } = await getInvestor({ token }).unwrap()
      if (success) {
        setUser(data)
        validation.setFieldValue("id", data.account.id)
        setAccountType(data.type)
      }
    } catch (error) {
      if (error.status === 404) {
        history("/login")
        toast.error(
          "We have not found any account, Please contact support team.",
          {
            id: "alreadyActiveInvestor",
          }
        )
      }
    }
  }

  useEffect(() => {
    if (token) {
      getUser()
    }
  }, [token])

  return (
    <div className="account-pages">
      <Row className="g-0">
        <Col md={7} lg={7} xl={7} className="p-0 m-0">
          <div className="log-in-blue-bg-cover">
            <div className="login-page-text">
              <h4>Managing your</h4>
              <h5>
                <span> CORPORATE TREASURY </span> was never so easy
              </h5>
              <p>Introducing Prachay ICDs</p>
            </div>
            <div className="login-page-bottom-text">
              <h4>DON'T LEAVE</h4>
              <h5>
                YOUR <span style={{ color: "#f0a634" }}>SURPLUS </span>{" "}
                UNMANAGED
              </h5>
            </div>
          </div>
        </Col>

        <Col md={5} lg={5} xl={5}>
          <div className="overflow-hidden login-form-wrapper px-1">
            <Card>
              <CardBody>
                <Link to="/" className="p-2">
                  <img src={logo} alt="" height="50" />
                </Link>
                <div className="login-text">
                  <h4>Reset Password</h4>
                  {/* <p>Please verify your account.</p> */}
                </div>

                <div className="pt-0">
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-2">
                        <Label className="col-form-label">
                          Password <span className="error">*</span>
                        </Label>
                        <div className="input-wrapper">
                          <Input
                            type={show ? "text" : "password"}
                            name="password"
                            className="form-control"
                            placeholder="Enter password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={validation.errors.password ? true : false}
                          />

                          <div onClick={() => setShow(!show)}>
                            {show ? (
                              <img src={hide} alt="" />
                            ) : (
                              <img src={eye} alt="" />
                            )}
                          </div>
                        </div>
                        {validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-2">
                        <Label className="col-form-label">
                          Confirm Password <span className="error">*</span>
                        </Label>
                        <div className="input-wrapper">
                          <Input
                            type={show ? "text" : "password"}
                            name="confirm_password"
                            className="form-control"
                            placeholder="Enter confirm Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.confirm_password || ""}
                            invalid={
                              validation.errors.confirm_password ? true : false
                            }
                          />
                          <div onClick={() => setShow(!show)}>
                            {show ? (
                              <img src={hide} alt="" />
                            ) : (
                              <img src={eye} alt="" />
                            )}
                          </div>
                          {validation.errors.confirm_password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.confirm_password}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block position-relative"
                          type="submit"
                          disabled={isFetching || isLoading}
                        >
                          {isLoading ? <Spinners /> : "Create new password"}
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default withRouter(ResetPassword)
